import { Component, OnInit, ElementRef } from '@angular/core';

import { ControlValidatorService } from '../../services/control-validator.service';

import { AbstractValueControlBase } from '../../types/abstract-value-control-base';

import { ControlTypeName } from '../../types/control-type-name';
import { LabelViewModel } from '../../types/control.types';

@Component({
  selector: 'df-paragraph',
  templateUrl: './paragraph.component.html',
  styleUrls: ['./paragraph.component.css']
})
export class ParagraphComponent extends AbstractValueControlBase<LabelViewModel> implements OnInit {
  type: string = ControlTypeName.paragraph;
  isDesign: boolean = false;
  model: LabelViewModel;

  constructor(protected element: ElementRef) {
    super();
  }

  ngOnInit() {
    if (this.hidden === undefined) {
      this.hidden = this.model.isHidden;
    }
  }

  bindEvents(): void {
    this.valueElement = this.getChildrenByPosition(this.element.nativeElement, 0, 0);
    this.bindEventsToEl(this.valueElement);
  }
}
